module.exports = __webpack_public_path__ + "img/symbol_7.cd67c8a3.png";